import { createContext, useContext, useState, useEffect, ReactNode } from "react";

type NavLayout = "left" | "top";

interface NavLayoutContextType {
  layout: NavLayout;
  setLayout: (layout: NavLayout) => void;
  toggleLayout: () => void;
}

const NavLayoutContext = createContext<NavLayoutContextType | null>(null);

const NAV_LAYOUT_KEY = "nav-layout";

export function NavLayoutProvider({ children }: { children: ReactNode }) {
  const [layout, setLayoutState] = useState<NavLayout>(() => {
    if (typeof window !== "undefined") {
      return (localStorage.getItem(NAV_LAYOUT_KEY) as NavLayout) || "left";
    }
    return "left";
  });

  const setLayout = (newLayout: NavLayout) => {
    setLayoutState(newLayout);
    localStorage.setItem(NAV_LAYOUT_KEY, newLayout);
  };

  const toggleLayout = () => {
    setLayout(layout === "left" ? "top" : "left");
  };

  return (
    <NavLayoutContext.Provider value={{ layout, setLayout, toggleLayout }}>
      {children}
    </NavLayoutContext.Provider>
  );
}

export function useNavLayout() {
  const context = useContext(NavLayoutContext);
  if (!context) {
    throw new Error("useNavLayout must be used within a NavLayoutProvider");
  }
  return context;
}
